// extracted by mini-css-extract-plugin
export default {"table":"table_table__tCErr","item":"table_item__bWEeG","features":"table_features__8g1mU"};